<template>
  <div>
    <div class="flex items-baseline">
      <h1 class="mb-6">Call dashboard</h1>

      <div class="ml-auto flex flex-grow items-baseline gap-x-4">
        <p class="flex-grow text-right">Select time span:</p>
        <div class="relative inline-block text-gray-700">
          <select
            v-model="activePeriod"
            class="w-full h-10 pl-3 pr-6 text-base placeholder-gray-600 rounded-lg appearance-none focus:shadow-outline"
            style="border: 1px solid rgba(60, 60, 60, 0.26)"
          >
            <option v-for="(date, idx) in availablePeriods" :key="idx" :value="date">{{ date }}</option>
          </select>
          <div class="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
            <svg class="w-4 h-4 fill-current" viewBox="0 0 20 20">
              <path
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd"
                fill-rule="evenodd"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Key figures -->
    <div class="grid grid-flow-row grid-cols-8 gap-6">
      <div
        class="vx-card col-span-2 flex flex-col"
        v-for="(item, idx) in data.general"
        :key="'GENERAL_' + idx"
      >
        <!--flex-row-reverse-->
        <div class="px-6 py-4 flex-grow flex justify-between items-start">
          <feather-icon
            :icon="[item.measure == 'Sentiment Score' && item.value.substr(0, item.value.length - 1) * 1 <= 50 ? 'FrownIcon' :
              item.measure == 'Sentiment Score' && item.value.substr(0, item.value.length - 1) * 1 ? 'SmileIcon' :
                item.measure == 'Total Calls' ? 'PhoneIcon' :
                  item.measure == 'Avg handling time' ? 'ClockIcon' :
                    item.measure == 'Confidence Score' ? 'CheckCircleIcon' : 'TrendingUpIcon',
            ]"
            class="p-3 mr-4 inline-flex rounded-full"
            :class="item.change.substr(0, 1) == '-' ? 'text-blue' : 'text-pink'"
            :style="{ background: item.change.substr(0, 1) == '-' ? `rgba(var(--vs-blue),.15)` : `rgba(var(--vs-pink),.15)` }"
          ></feather-icon>
          <div class="flex-grow">
            <div class="flex gap-x-4 items-baseline">
              <h2
                class="mb-2 font-bold"
                :class="item.change.substr(0, 1) == '-' ? 'text-blue' : 'text-pink'"
              >{{ item.value }}</h2>

              <div v-if="item.change.substr(0, 1) == '-'" class="text-blue">({{ item.change }})</div>
              <div v-else class="text-pink">(+{{ item.change }})</div>
            </div>
            <div class="text-sm">{{ item.measure }}</div>
          </div>
        </div>
      </div>

      <!-- <div class="vx-card col-span-2 p-6 flex"
                v-for="(item, idx) in data.general"
                :key="'GENERAL_' + idx"
            >
            {{ item.measure }} {{ item.value }} {{ item.change }}
      </div>-->

      <!-- Call Reasons column p-6 -->
      <div class="vx-card col-span-4 pb-6 flex flex-col">
        <h2 class="p-6">Call reasons and sentiments</h2>
        <dashboard-call-reasons v-if="loaded" :intentions="data.intention" />
      </div>

      <div class="vx-card col-span-4 p-6 flex flex-col gap-y-4" v-if="loaded">
        <!-- Subcluster -->
        <h2 class="mb-6">Top &amp; flop sentiments</h2>

        <div
          v-for="(item, idx) in data.sentiment"
          :key="'SENTIMENT_' + idx"
          class="grid grid-cols-2 items-center"
        >
          <p>{{ item.measure }} (n = {{ item.reviews }})</p>
          <vs-progress
            :percent="1*item.sentiment"
            :color="getColor(item.sentiment)"
            style="height: 8px"
          />
        </div>

        <div class="grid grid-cols-4 text-sm text-gray-500 -mt-4">
          <div class="col-start-3">low</div>
          <div class="text-right">high</div>
        </div>

        <!-- <ul>
                <li
                    v-for="(item, idx) in data.sentiment"
                    :key="'SENTIMENT_' + idx"
                >
                <span :class="item.ranking.indexOf('Top') > -1 ? 'text-green' : 'text-red' ">{{ item.ranking }}</span>
                {{ item.measure }} {{ item.ranking }} {{ item.reviews }}# - sentiment: {{ item.sentiment }}</li>
        </ul>-->

        <!-- <h1>Intention Analysis</h1>
            Total calls: {{ intentionTotalCalls }}
            <ul>
                <li
                    v-for="(item, idx) in data.intention"
                    :key="'INTENTION_' + idx"
                >
                <span :class="item.ranking.indexOf('Top') > -1 ? 'text-green' : 'text-red' ">{{ item.ranking }}</span>
                {{ item.measure }} {{ item.ranking }} {{ item.reviews }}# - sentiment: {{ item.sentiment }}</li>
        </ul>-->
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import _ from 'lodash';
import DashboardCallReasons from "@/components/cat/DashboardCallReasons.vue";

export default {
  components: { DashboardCallReasons },
  data() {
    return {
      loaded: false,
      allPeriods: Vue.observable([]),
      json: null,
      activePeriod: null,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const spreadsheetId = "1BSyjUzyA_sBqxPk3Fmgx26bWFedPEiJf5gM03kfqMAQ"; // CruiseCallsTest
      let resp = await fetch(
        `https://docs.google.com/spreadsheets/d/${spreadsheetId}/gviz/tq?tqx=out:json&headers=1`
      ),
        text = await resp.text();
      this.json = JSON.parse(text.substr(47).slice(0, -2));
      this.parseData()
      this.loaded = true;
    },
    parseData() {
      let that = this,
        parsed = this.json.table.rows.map(function (row) {
          let c = _.map(row.c, 'v');
          return ({
            measure: c[0],
            cluster: c[1].toLowerCase(),
            period: c[3],
            value: c[4],
            change: c[5],
            ranking: c[6],
            reviews: c[7],
            sentiment: c[8]
          });
        }),
        byPeriod = _.groupBy(parsed, 'period');

      _.each(byPeriod, function (val, key) {
        byPeriod[key] = _.groupBy(val, 'cluster');
      })
      console.log('BP', byPeriod);
      this.allPeriods = byPeriod;
      this.activePeriod = Object.keys(byPeriod)[0];
    },
    getColor(senti) {
      var colors = ["#4a76c4", "#5b71bc", "#6c6cb5", "#7d67ad", "#8e62a5", "#a05e9e", "#b15996", "#c2548e", "#d34f87", "#e44a7f"];
      let i = Math.floor((senti * 1 - 1) / 10);
      return colors[i]
    }
  },
  computed: {
    intentionTotalCalls() {
      return _.map(this.data.intention, 'reviews').reduce((a, b) => a + 1 * b, 0);
    },
    data() {
      return this.allPeriods[this.activePeriod];
    },
    availablePeriods() {
      return Object.keys(this.allPeriods);
    }
  }
}
</script>

<style>
.text-red {
  color: #bb0033;
}
</style>
